<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log('------------------------------------------------------------')
      console.log('This is a development version of the Hokodo Partner Portal')
      console.log('ROOT_API:', process.env.ROOT_API)
      console.log('ROOT_STATIC:', process.env.ROOT_STATIC)
      console.log('------------------------------------------------------------')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue